import type * as React from 'react';
import { FileTrigger, type FileTriggerProps } from 'react-aria-components';
import { Button } from '../button';

type _FileTriggerProps = Omit<FileTriggerProps, 'children'> & React.ComponentProps<typeof Button>;

function _FileTrigger(props: _FileTriggerProps) {
  const { acceptDirectory, acceptedFileTypes, allowsMultiple, defaultCamera, onSelect, ...other } = props;

  return (
    <FileTrigger
      acceptDirectory={acceptDirectory}
      acceptedFileTypes={acceptedFileTypes}
      allowsMultiple={allowsMultiple}
      defaultCamera={defaultCamera}
      onSelect={onSelect}
    >
      <Button {...other} />
    </FileTrigger>
  );
}

export { _FileTrigger as FileTrigger };
